// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"e3cd96b3","453":"733f28f0","455":"92a3ce57","611":"91cefd2a","924":"1892a757","927":"6e1b0776","977":"968ab781"}[chunkId] + ".chunk.js";
};